// Skills icons - https://icon-sets.iconify.design/
import { Icon } from "@iconify/react";

// Navbar Logo image (add your image to the src/images directory and uncomment the line below to import your image)
import newLogo from "./images/nav-logo.jpeg"

// Hero Images (add your images to the /images directory with the same names)
import HeroLight from "./images/hero-light.jpeg";
import HeroDark from "./images/hero-dark.jpeg";
import ProfilePic from "./images/profile-pic-2.jpeg";

// Projects Images (add your images to the images directory and import below)
import Logo from "./images/logo.svg";
import TandemImage from "./images/projects-tandem.png";
import OpenFDAImage from "./images/projects-openFDA.jpeg";
import UnitubeImage from "./images/projects-unitube.png";

/* START HERE
 **************************************************************
  Add your GitHub username (string - "YourUsername") below.
*/
export const githubUsername = "CarolusSolis";

// Navbar Logo image
export const navLogo = newLogo;

/* Main
 ************************************************************** 
  Add a custom blog icon or update the hero images for the Main section.
*/
export const Blog = null;
export const Light = HeroLight;
export const Dark = HeroDark;
export const Avatar = ProfilePic;

// Hero subtitle (displayed below name)
export const heroSubtitle = "ML Engineer";

/* About Me
 **************************************************************
  Add a second paragraph for the about me section.
*/
export const moreInfo = `
  Curious, creative, and open-minded, I'm always looking to engage deeply with the world around me. Born in Beijing, 
  the great ancient capital of China, I developed a fascination for history at an early age and have been a lifelong 
  learner ever since. I'd eagerly welcome a discussion about the past or the future of humanity—history has taught me 
  the value of perseverance and to keep experimenting until I find what truly fits.

  Today, I find myself in the midst of another fascinating transition: the AI revolution. With a Master's degree in 
  AI and Innovation from Carnegie Mellon University, I'm excited not only to observe but to actively contribute to 
  this transformative era, experimenting and exploring to shape our future.
`;

/* Skills
 ************************************************************** 
  Add or remove skills in the SAME format below, choose icons here - https://icon-sets.iconify.design/
*/
export const skillData = [
  // Row 1: ML Frameworks & Hardware
  {
    id: 1,
    skill: <Icon icon="cib:pytorch" className="display-4" />,
    name: "PyTorch",
  },
  {
    id: 2,
    skill: <Icon icon="mdi:chip" className="display-4" />,
    name: "ML Accelerators (AWS Trainium)",
  },
  {
    id: 3,
    skill: <Icon icon="simple-icons:langchain" className="display-4" />,
    name: "LangChain / LangGraph",
  },
  // Row 2: AI Tools & LLMs
  {
    id: 4,
    skill: <Icon icon="simple-icons:openai" className="display-4" />,
    name: "OpenAI & other LLMs",
  },
  {
    id: 5,
    skill: <Icon icon="simple-icons:anthropic" className="display-4" />,
    name: "Claude Code",
  },
  {
    id: 6,
    skill: <Icon icon="mdi:aws" className="display-4" />,
    name: "AWS & other cloud services",
  },
  // Row 3: Languages & Tools
  {
    id: 7,
    skill: <Icon icon="mdi:language-python" className="display-4" />,
    name: "Python",
  },
  {
    id: 8,
    skill: <Icon icon="mdi:language-c" className="display-4" />,
    name: "C / C++",
  },
  {
    id: 9,
    skill: <Icon icon="bi:git" className="display-4" />,
    name: "Git",
  },
];

// Resume link (string - "https://YourResumeUrl") - I am using CloudFront to share my resume (https://docs.aws.amazon.com/AmazonCloudFront/latest/DeveloperGuide/Introduction.html)
export const resume = null;

/* Projects
 ************************************************************** 
  List your top projects below - they will be imported by About.js and used in the Projects component. 
*/
export const projectsData = [
  {
    id: 1,
    name: "Tandem for Couples",
    description: "A platform for long-distance couples to connect, featuring an LLM Agent for resource curation and AI recommendation algorithms. Helps couples maintain strong relationships despite physical distance.",
    image: TandemImage,
    demo: "https://www.tandemforcouples.com",
    technologies: ["AI Agent", "Mobile Development", "Full-Stack Development"]
  },
  {
    id: 2,
    name: "ChatFDA: Patient Safety Checker",
    description: "Winner of CMU HackAuton 2023. A tool that enhances patient safety by utilizing LLM RAG and the OpenFDA database to provide comprehensive safety checks and recommendations.",
    image: OpenFDAImage,
    technologies: ["LLM", "AI", "Healthcare Tech"],
    paper: "https://arxiv.org/abs/2312.12746",
    url: "https://github.com/autonlab/2023.hackAuton/tree/main/prescription_checker",
    demo: "https://docs.google.com/presentation/d/1_7c2VWIehdPI17RAsOAURb0NXztSJnrfeltFkSSoFEk/edit?usp=sharing"
  },
  {
    id: 3,
    name: "Ünitube: AI Video Translation Platform",
    description: "An innovative video translation platform that earned Top 5 recognition among 89 teams at CMU TartanHack. Leverages AI to provide seamless video content translation.",
    image: UnitubeImage,
    technologies: ["AI", "Video Translation", "Deep Learning"],
    url: "https://github.com/CarolusSolis/unitube",
    // TODO: add a demo
  }
];

/* Contact Info
 ************************************************************** 
  Add your formspree endpoint below.
  https://formspree.io/
*/
export const formspreeUrl = "https://formspree.io/f/xanyykpw";

// Footer icons theme (light or dark)
export const footerTheme = "dark";

// Books data
export const booksData = [
  {
    title: "Sapiens",
    author: "Yuval Noah Harari",
    coverUrl: "https://m.media-amazon.com/images/I/713jIoMO3UL._AC_UF1000,1000_QL80_.jpg",
    intro: "A captivating journey through the history of humankind, exploring how we evolved from simple bands of hunter-gatherers to creators of intricate societies.",
    takeaway: "My biggest takeaway from this book is that many of the things we take for granted, like ideas, nations, or organizations, are merely figments of our collective imaginations. They only hold power over us as long as we and others believe in them. But it is precisely this ability that makes humans so uniquely powerful and ultimately successful—we can believe in shared fictions, allowing us to find common ground across vast numbers of people and collaborate to build complex societies."
  },
  {
    title: "The Rise and Fall of the Third Reich",
    author: "William L. Shirer",
    coverUrl: "https://m.media-amazon.com/images/I/81OfSW49oIL._AC_UF1000,1000_QL80_.jpg",
    intro: "A gripping account of the rise of Nazi Germany and the inner workings of the Third Reich, written by someone who witnessed these events firsthand.",
    takeaway: "One key insight I gained from this book is that people are often prone to believing what they want to believe. For example, British Prime Minister Chamberlain chose to believe Hitler's promise of peace, despite Hitler's clearly stated expansionist agenda that was repeated both in his book and numerous speeches. Indeed, it was demonstrated time and time again that our narrative selves prefer convenient stories over hard facts, and that is one key reminder for our own lives as well as society in general."
  },
  {
    title: "The Story of the Roman People",
    author: "Nanami Shiono",
    coverUrl: "https://m.media-amazon.com/images/I/91z2R4YZnfL._UF1000,1000_QL80_.jpg",
    intro: "An engaging and comprehensive narrative that traces the rise and fall of Rome, offering a deeply human perspective on the empire's history.",
    takeaway: "My take: As Scipio Aemilianus watched Carthage burn in 146 BCE, he had a poignant moment of reflection. He wept as he witnessed the destruction of Carthage, a once-great power. When asked why he was crying, Scipio replied, 'A glorious moment, Polybius; but I have a dreadful foreboding that one day the same doom will be pronounced on my own country.' Yet the actual fall of Rome contained no such dramatic final moments—in many places, people simply forgot about the existence of the empire. What does that say about the once-great and famous things and personalities in our own society?"
  }
  // Add more books as needed
];
